import React from "react";
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {pasillosResources} from "../endpoints";

class DialogAgregarEditarPasillo extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            iniciar: true,
            nombre: props.accion === 'agregar' ? '' : props.pasillo.nombre || '',
            numero: props.accion === 'agregar' ? '' : props.pasillo.numero || '',
            area: props.accion === 'agregar' ? '' : props.pasillo.area || '',
            idPasillo: props.accion === 'agregar' ? '' : props.pasillo.id, 
            padre: this.props.padre,
            accion: props.accion,
            msgError: ''
        }
        
    };

    verificarCampos = (num, pArea) =>{
        if(num === '') {
            this.setState({msgError: "Debe ingresar un numero de pasillo"})
            return false
        }
        if(pArea === '') {
            this.setState({msgError: "Debe ingresar un area al pasillo"})
            return false
        }
        return true
    }

    handleChange = e =>{
        const { name, value } = e.target;
        
        if (name === 'numero') {
            if (/^\d*$/.test(value)) { // Solo permite números
                this.setState({ [name]: value });
            }
        } else {
            this.setState({ [name]: value.replace("/", "") });
        }
    }

    handleClick = () =>{
        if(this.state.accion === 'agregar'){
            const nombre_pasillo = this.state.nombre;
            const numero_pasillo = this.state.numero;
            const area_pasillo = this.state.area;
            if(!this.verificarCampos(numero_pasillo, area_pasillo)){
                this.props.refrescar(this.state.msgError, "error")
            }

            const pasillo = {
               descripcion: nombre_pasillo,
               numero: numero_pasillo,
               area: area_pasillo
            };
            pasillosResources.agregarPasillo(pasillo).then(async response => {
                if(response) return await response.json()
            }).then( result => {
                if(result.message){
                    this.setState({
                        nombre: ''
                    });
                    this.props.refrescar(result.message, result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else{
            const pasilloId = this.state.idPasillo.match(/\d+/)[0];
            const nombre_pasillo = this.state.nombre;
            const numero_pasillo = this.state.numero;
            const area_pasillo = this.state.area;
            if(!this.verificarCampos(numero_pasillo, area_pasillo)){
                this.props.refrescar(this.state.msgError, "error")
            }
            const pasillo = {
               descripcion: nombre_pasillo,
               numero: numero_pasillo,
               area: area_pasillo
            };
            pasillosResources.editarPasillo(pasilloId, pasillo).then(async response => {
                if(response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.setState ={
                        iniciar: true,
                    }
                    this.props.refrescar(result.message, result.severity)
                }else{
                    throw new Error('Something went wrong ...');
                }

            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }

    }

    render() {
        return(
            <Dialog
                open={this.state.iniciar}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            <TextField type={'text'} autoFocus={true} value={this.state.numero} name="numero" label="Número" fullWidth onChange={this.handleChange}/>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            <TextField type={'text'} autoFocus={false} value={this.state.nombre} name="nombre" label="Descripción" fullWidth onChange={this.handleChange}/>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            <TextField type={'text'} autoFocus={false} value={this.state.area} name="area" label="Area" fullWidth onChange={this.handleChange}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button disabled={!this.state.nombre} variant="contained"  color="primary" onClick={this.handleClick}>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogAgregarEditarPasillo;